import { FC } from 'react';
import { useParams } from 'react-router-dom';

import DeleteResourceModal from '@/shared/components/modals/ResourceActionModals/03-DeleteResourceModal';
import { useTeamStore } from '@/stores';
import { SetStateMethod } from '@/types';

interface DeleteTeamModalProps {
    open: boolean;
    setOpen: SetStateMethod<boolean>;
}

const DeleteTeamModal: FC<DeleteTeamModalProps> = ({ open, setOpen }): JSX.Element => {
    const { teamId = '' } = useParams<{ teamId: string }>();
    const { selectedTeam } = useTeamStore();

    return (
        <DeleteResourceModal
            open={open}
            resource={{ id: teamId, name: selectedTeam?.name }}
            setOpen={setOpen}
            singularResource='team'
        />
    );
};

export default DeleteTeamModal;
